import apiClient from './apiClient';

class TeamService {
  async getMembers() {
    try {
      return await apiClient.get('/team_members');
    } catch (error) {
      const err = error.response?.data;
      throw new Error(err?.error || 'Failed to fetch team members');
    }
  }

  async addMember(member) {
    try {
      return await apiClient.post('/team_members', member);
    } catch (error) {
      const err = error.response?.data;
      throw new Error(err?.error || 'Failed to add team member');
    }
  }

  async removeMember(id) {
    try {
      return await apiClient.delete(`/team_members/${id}`);
    } catch (error) {
      const err = error.response?.data;
      throw new Error(err?.error || 'Failed to remove team member');
    }
  }

  async getMemberWorklogs(id, { startDate, endDate, refresh = false }) {
    try {
      return await apiClient.get(`/team_members/${id}/worklogs`, {
        params: {
          start_date: startDate,
          end_date: endDate,
          ...(refresh ? { refresh: true } : {}),
        },
      });
    } catch (error) {
      const err = error.response?.data;
      throw new Error(err?.error || 'Failed to fetch worklogs');
    }
  }
}

export const teamService = new TeamService();